export default "__VITE_ASSET__BW_vteBK__"